import { Tabs } from "antd";
import { PageCard } from "src/common/styles/styles"
import { SystemSettings } from "../SystemSettings";
import { SystemDescriptions } from "src/common/descriptions";
import { useEffect } from "react";
import useUserPermission from "src/hooks/useUserPermissions";
import { USER_SCOPES } from "src/hooks/UserPermission";
import { CompanyData } from "../CompanyData";

export const Settings = () => {
    const { validateUserScopeForPage } = useUserPermission()

    useEffect(() => {
        validateUserScopeForPage(USER_SCOPES.SETTINGS)
    }, [])

    const descriptions = SystemDescriptions.PAGES.SETTINGS

    const settingItems = [
        {
            label: descriptions.COMPANY_DATA.TITLE,
            key: "COMPANY_DATA",
            children: <CompanyData />,
        },
        {
            label: descriptions.SYSTEM_SETTINGS.TITLE,
            key: "SYSTEM_SETTINGS",
            children: <SystemSettings />,
        },
    ]

    return (
        <PageCard size="small" title={""} >
            <Tabs
                defaultActiveKey="SYSTEM_SETTINGS"
                type="card"
                size={"small"}
                items={settingItems}
            />
        </PageCard>
    )
}
